import { DropdownEditor } from '@approvalmax/ui';
import { PlainDataProvider } from 'modules/data-providers';
import { LineItemsTable } from 'pages/requestForm/components/lineItemsSection/LineItemsTable/LineItemsTable';
import { SectionContainer } from 'pages/requestForm/components/SectionContainer';
import { findLineAmountType, lineAmountTypeReferences } from 'pages/requestForm/data/xero/statics/lineAmountType';
import { memo } from 'react';

import { MANUAL_JOURNAL_LINES_LIMIT } from './ManualJournalLines.constants';
import { useTableDef } from './ManualJournalLines.hooks';
import { messages } from './ManualJournalLines.messages';
import { HeaderRight, LineAmountTypeLabel, LineAmountTypeWrapper, SectionHeader } from './ManualJournalLines.styles';
import { ManualJournalLinesProps } from './ManualJournalLines.types';

const ManualJournalLines = memo<ManualJournalLinesProps>((props) => {
    const {
        lines,
        lineAmountType,
        readonlyFields,
        requiredFields,
        showErrors,
        showErrorsOnEmptyLine,
        onAddLine,
        onCloneLine,
        onRemoveLine,
        onReorderLines,
        onLineFieldUpdate,
        onLineAmountTypeChange,
        onLineTrackingCategoryChange,
    } = props;

    const tableDef = useTableDef({
        lineAmountType,
        readonlyFields,
        requiredFields,
        showErrors,
        showErrorsOnEmptyLine,
        onLineFieldUpdate,
        onLineTrackingCategoryChange,
    });

    return (
        <SectionContainer
            title={
                <SectionHeader>
                    <div>{messages.sectionHeader}</div>

                    <HeaderRight>
                        <LineAmountTypeWrapper>
                            <LineAmountTypeLabel>{messages.amountsAre}</LineAmountTypeLabel>

                            <PlainDataProvider items={lineAmountTypeReferences}>
                                <DropdownEditor
                                    value={findLineAmountType(lineAmountType)}
                                    onChange={onLineAmountTypeChange}
                                    buttonComponent={DropdownEditor.NoFilterButton}
                                />
                            </PlainDataProvider>
                        </LineAmountTypeWrapper>
                    </HeaderRight>
                </SectionHeader>
            }
            noPadding
        >
            <LineItemsTable
                columnDefinitions={tableDef}
                lineItems={lines}
                invalid={false}
                onReorder={onReorderLines}
                onRemoveLine={onRemoveLine}
                onCloneLine={onCloneLine}
                onAddLine={onAddLine}
                canAddLine={true}
                linesNumberReached={lines.length >= MANUAL_JOURNAL_LINES_LIMIT}
            />
        </SectionContainer>
    );
});

export default ManualJournalLines;
